export const ADD_WISHLIST_FAILURE = 'ADD_WISHLIST_FAILURE';
export const ADD_WISHLIST_REQUEST = 'ADD_WISHLIST_REQUEST';
export const ADD_WISHLIST_SUCCESS = 'ADD_WISHLIST_SUCCESS';
